import { repeat } from "lodash-es"

export const getInequality = (form = 0, to = 0) => {
  const _form = Number(form)
  const _to = Number(to)
  return _form > _to ? -1 : _form === _to ? 0 : 1
}

export const toFixed = (val, fixed = 2) => {
  const digits = Number("1" + repeat('0', fixed))
  return Math.round(Number(val) * digits) / digits
}

export const getRatio = (from, to) => {
  return (Number(to) / Number(from) * 100) - 100
}